import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import config from 'config/index';

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    defaultNS: 'menus',
    fallbackLng: 'en',
    debug: false, //If you want to debug/want to see the response of the api turn it to true
    // lng: lan ? `${lan}` : 'en',
    backend: {
      loadPath: `${config.host}/static/get-language/{{lng}}`,
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
